import Header from "../components/header";
import Footer from "../components/footer";
import AboutMain from "../components/about/about-main";
import WhyUs from "../components/about/why-us";
import WhoNWhat from "../components/about/who-n-what";
import UsInNumbers from "../components/about/us-in-numbers";
import Blog from "../components/about/blog";

function About() {
    return (  
        <> 
         <AboutMain />
         <WhyUs />
         <UsInNumbers />
         <WhoNWhat />
         <Blog />
        </>
    );
}

export default About;